"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _clearFixMixin = require("../clearFixMixin");
/** @class PageMixin */
/** @method */
var PageMixin = function PageMixin(props) {
  var backgroundToken = 'Page.backgroundColor';
  if (typeof props.backgroundColor !== 'undefined') {
    backgroundToken = "colors." + props.backgroundColor;
  }
  return (0, _styledToken.default)(backgroundToken, function (backgroundColor) {
    var styles = [(0, _clearFixMixin.clearFixMixin)(props)];
    if (backgroundColor) {
      styles.push("background-color: " + backgroundColor + ";");
    }
    return styles;
  })(props);
};
exports.PageMixin = PageMixin;